import { AuthenticatedRoute } from '@core/components';
import { LabelManagementPage } from '@system-config/label-management/pages';
import type { RouteObject } from 'react-router-dom';

/**
 * Get route configuration for the System Config domain
 * @returns Array of route objects for the System Config domain
 */
export function getRouteConfig(): RouteObject[] {
  return [
    {
      path: 'label-management',
      element: <AuthenticatedRoute requiresSystemAdmin />,
      children: [
        {
          index: true,
          element: <LabelManagementPage />,
        },
      ],
    },
  ];
}
